import { makeApiActionCreatorV3 } from '@actions/utils';
import {
  createRequestTypes,
  START,
  SUCCESS,
  ERROR,
} from '@modules/appraisal/actions/global';

import * as api from '../api/assignment';

const namespace = 'MOBILE';

export const SET_PRIORITY_SELECTION = createRequestTypes(
  `${namespace}/SET_PRIORITY_SELECTION`,
);

export const setPrioritySelection = payload => ({
  type: SET_PRIORITY_SELECTION,
  payload,
});

export const CREATE_ASSIGNMENT = createRequestTypes(
  `${namespace}/CREATE_ASSIGNMENT`,
);

export const createAssignment = makeApiActionCreatorV3(
  api.createAssignment,
  CREATE_ASSIGNMENT[START],
  CREATE_ASSIGNMENT[SUCCESS],
  CREATE_ASSIGNMENT[ERROR],
);

export const FETCH_ASSIGNMENT = createRequestTypes(
  `${namespace}/FETCH_ASSIGNMENT`,
);

export const fetchAssignment = makeApiActionCreatorV3(
  api.fetchAssignment,
  FETCH_ASSIGNMENT[START],
  FETCH_ASSIGNMENT[SUCCESS],
  FETCH_ASSIGNMENT[ERROR],
);

export const UPDATE_ASSIGNMENT = createRequestTypes(
  `${namespace}/UPDATE_ASSIGNMENT`,
);

export const updateAssignment = makeApiActionCreatorV3(
  api.updateAssignment,
  UPDATE_ASSIGNMENT[START],
  UPDATE_ASSIGNMENT[SUCCESS],
  UPDATE_ASSIGNMENT[ERROR],
);

export const SET_ASSIGNMENT_AS_COMPLETED = createRequestTypes(
  `${namespace}/SET_ASSIGNMENT_AS_COMPLETED`,
);

export const setAssignmentAsCompleted = makeApiActionCreatorV3(
  api.setAssignmentAsCompleted,
  SET_ASSIGNMENT_AS_COMPLETED[START],
  SET_ASSIGNMENT_AS_COMPLETED[SUCCESS],
  SET_ASSIGNMENT_AS_COMPLETED[ERROR],
);

export const REOPEN_ASSIGNMENT = createRequestTypes(
  `${namespace}/REOPEN_ASSIGNMENT`,
);

export const reopenAssignment = makeApiActionCreatorV3(
  api.reopenAssignment,
  REOPEN_ASSIGNMENT[START],
  REOPEN_ASSIGNMENT[SUCCESS],
  REOPEN_ASSIGNMENT[ERROR],
);

export const FETCH_ASSIGNMENT_CRITERIA = createRequestTypes(
  `${namespace}/FETCH_ASSIGNMENT_CRITERIA`,
);

export const fetchAssignmentCriteria = makeApiActionCreatorV3(
  api.fetchAssignmentCriteria,
  FETCH_ASSIGNMENT_CRITERIA[START],
  FETCH_ASSIGNMENT_CRITERIA[SUCCESS],
  FETCH_ASSIGNMENT_CRITERIA[ERROR],
);

export const UPDATE_ASSIGNMENT_CRITERIA = createRequestTypes(
  `${namespace}/UPDATE_ASSIGNMENT_CRITERIA`,
);

export const updateAssignmentCriteria = makeApiActionCreatorV3(
  api.updateAssignmentCriteria,
  UPDATE_ASSIGNMENT_CRITERIA[START],
  UPDATE_ASSIGNMENT_CRITERIA[SUCCESS],
  UPDATE_ASSIGNMENT_CRITERIA[ERROR],
);

export const FETCH_ASSIGNMENT_QUERY = createRequestTypes(
  `${namespace}/FETCH_ASSIGNMENT_QUERY`,
);

export const fetchAssignmentQuery = makeApiActionCreatorV3(
  api.fetchAssignmentQuery,
  FETCH_ASSIGNMENT_QUERY[START],
  FETCH_ASSIGNMENT_QUERY[SUCCESS],
  FETCH_ASSIGNMENT_QUERY[ERROR],
);

export const UPDATE_ASSIGNMENT_QUERY = createRequestTypes(
  `${namespace}/UPDATE_ASSIGNMENT_QUERY`,
);

export const updateAssignmentQuery = makeApiActionCreatorV3(
  api.updateAssignmentQuery,
  UPDATE_ASSIGNMENT_QUERY[START],
  UPDATE_ASSIGNMENT_QUERY[SUCCESS],
  UPDATE_ASSIGNMENT_QUERY[ERROR],
);

export const VALIDATE_ASSIGNMENT_QUERY = createRequestTypes(
  `${namespace}/VALIDATE_ASSIGNMENT_QUERY`,
);

export const validateAssignmentQuery = makeApiActionCreatorV3(
  api.validateAssignmentQuery,
  VALIDATE_ASSIGNMENT_QUERY[START],
  VALIDATE_ASSIGNMENT_QUERY[SUCCESS],
  VALIDATE_ASSIGNMENT_QUERY[ERROR],
);

export const FETCH_ASSIGNMENT_PROPERTIES = createRequestTypes(
  `${namespace}/FETCH_ASSIGNMENT_PROPERTIES`,
);

export const fetchAssignmentProperties = makeApiActionCreatorV3(
  api.fetchAssignmentProperties,
  FETCH_ASSIGNMENT_PROPERTIES[START],
  FETCH_ASSIGNMENT_PROPERTIES[SUCCESS],
  FETCH_ASSIGNMENT_PROPERTIES[ERROR],
);

export const INSERT_ASSIGNMENT_PROPERTY = createRequestTypes(
  `${namespace}/INSERT_ASSIGNMENT_PROPERTY`,
);

export const insertAssignmentProperty = makeApiActionCreatorV3(
  api.insertAssignmentProperty,
  INSERT_ASSIGNMENT_PROPERTY[START],
  INSERT_ASSIGNMENT_PROPERTY[SUCCESS],
  INSERT_ASSIGNMENT_PROPERTY[ERROR],
);

export const MASS_CAPTURE_ASSIGNMENT_PRIORITIES = createRequestTypes(
  `${namespace}/MASS_CAPTURE_ASSIGNMENT_PRIORITIES`,
);

export const massCaptureAssignmentPriorities = makeApiActionCreatorV3(
  api.massCaptureAssignmentPriorities,
  MASS_CAPTURE_ASSIGNMENT_PRIORITIES[START],
  MASS_CAPTURE_ASSIGNMENT_PRIORITIES[SUCCESS],
  MASS_CAPTURE_ASSIGNMENT_PRIORITIES[ERROR],
);

export const CAPTURE_ASSIGNMENT_PROPERTY = createRequestTypes(
  `${namespace}/CAPTURE_ASSIGNMENT_PROPERTY`,
);

export const captureAssignmentProperty = makeApiActionCreatorV3(
  api.captureAssignmentProperty,
  CAPTURE_ASSIGNMENT_PROPERTY[START],
  CAPTURE_ASSIGNMENT_PROPERTY[SUCCESS],
  CAPTURE_ASSIGNMENT_PROPERTY[ERROR],
);

export const PREVIEW_ASSIGNMENT_CODE_COUNTS = createRequestTypes(
  `${namespace}/PREVIEW_ASSIGNMENT_CODE_COUNTS`,
);

export const previewAssignmentCodeCounts = makeApiActionCreatorV3(
  api.previewAssignmentCodeCounts,
  PREVIEW_ASSIGNMENT_CODE_COUNTS[START],
  PREVIEW_ASSIGNMENT_CODE_COUNTS[SUCCESS],
  PREVIEW_ASSIGNMENT_CODE_COUNTS[ERROR],
);

export const VALIDATE_ASSIGNMENT_CRITERIA = createRequestTypes(
  `${namespace}/VALIDATE_ASSIGNMENT_CRITERIA`,
);

export const validateAssignmentCriteria = makeApiActionCreatorV3(
  api.validateAssignmentCriteria,
  VALIDATE_ASSIGNMENT_CRITERIA[START],
  VALIDATE_ASSIGNMENT_CRITERIA[SUCCESS],
  VALIDATE_ASSIGNMENT_CRITERIA[ERROR],
);

export const SET_ASSIGNMENT_PROPERTY_PRIORITY = createRequestTypes(
  `${namespace}/SET_ASSIGNMENT_PROPERTY_PRIORITY`,
);

export const setAssignmentPropertyPriority = makeApiActionCreatorV3(
  api.setAssignmentPropertyPriority,
  SET_ASSIGNMENT_PROPERTY_PRIORITY[START],
  SET_ASSIGNMENT_PROPERTY_PRIORITY[SUCCESS],
  SET_ASSIGNMENT_PROPERTY_PRIORITY[ERROR],
);

export const CLEAR_ASSIGNMENT_PROPERTY_PRIORITY = createRequestTypes(
  `${namespace}/CLEAR_ASSIGNMENT_PROPERTY_PRIORITY`,
);

export const clearAssignmentPropertyPriority = makeApiActionCreatorV3(
  api.clearAssignmentPropertyPriority,
  CLEAR_ASSIGNMENT_PROPERTY_PRIORITY[START],
  CLEAR_ASSIGNMENT_PROPERTY_PRIORITY[SUCCESS],
  CLEAR_ASSIGNMENT_PROPERTY_PRIORITY[ERROR],
);

export const SET_ASSIGNMENT_ALL_PRIORITY = createRequestTypes(
  `${namespace}/SET_ASSIGNMENT_ALL_PRIORITY`,
);

export const setAssignmentAllPriority = makeApiActionCreatorV3(
  api.setAssignmentAllPriority,
  SET_ASSIGNMENT_ALL_PRIORITY[START],
  SET_ASSIGNMENT_ALL_PRIORITY[SUCCESS],
  SET_ASSIGNMENT_ALL_PRIORITY[ERROR],
);

export const CLEAR_ASSIGNMENT_ALL_PRIORITY = createRequestTypes(
  `${namespace}/CLEAR_ASSIGNMENT_ALL_PRIORITY`,
);

export const clearAssignmentAllPriority = makeApiActionCreatorV3(
  api.clearAssignmentAllPriority,
  CLEAR_ASSIGNMENT_ALL_PRIORITY[START],
  CLEAR_ASSIGNMENT_ALL_PRIORITY[SUCCESS],
  CLEAR_ASSIGNMENT_ALL_PRIORITY[ERROR],
);

export const FETCH_ASSIGNMENT_PRIORITIES = createRequestTypes(
  `${namespace}/FETCH_ASSIGNMENT_PRIORITIES`,
);

export const fetchAssignmentPriorities = makeApiActionCreatorV3(
  api.fetchAssignmentPriorities,
  FETCH_ASSIGNMENT_PRIORITIES[START],
  FETCH_ASSIGNMENT_PRIORITIES[SUCCESS],
  FETCH_ASSIGNMENT_PRIORITIES[ERROR],
);

export const CREATE_ASSIGNMENT_CHANGESET = createRequestTypes(
  `${namespace}/CREATE_ASSIGNMENT_CHANGESET`,
);

export const createAssignmentChangeset = makeApiActionCreatorV3(
  api.createAssignmentChangeset,
  CREATE_ASSIGNMENT_CHANGESET[START],
  CREATE_ASSIGNMENT_CHANGESET[SUCCESS],
  CREATE_ASSIGNMENT_CHANGESET[ERROR],
);

export const FETCH_ASSIGNMENT_CHANGESETS = createRequestTypes(
  `${namespace}/FETCH_ASSIGNMENT_CHANGESETS`,
);

export const fetchAssignmentChangesets = makeApiActionCreatorV3(
  api.fetchAssignmentChangesets,
  FETCH_ASSIGNMENT_CHANGESETS[START],
  FETCH_ASSIGNMENT_CHANGESETS[SUCCESS],
  FETCH_ASSIGNMENT_CHANGESETS[ERROR],
);

export const FETCH_ASSIGNMENT_CHANGESET_PROPERTIES = createRequestTypes(
  `${namespace}/FETCH_ASSIGNMENT_CHANGESET_PROPERTIES`,
);

export const fetchAssignmentChangesetProperties = makeApiActionCreatorV3(
  api.fetchAssignmentChangesetProperties,
  FETCH_ASSIGNMENT_CHANGESET_PROPERTIES[START],
  FETCH_ASSIGNMENT_CHANGESET_PROPERTIES[SUCCESS],
  FETCH_ASSIGNMENT_CHANGESET_PROPERTIES[ERROR],
);

export const UPDATE_ASSIGNMENT_CHANGESET_PROPERTY = createRequestTypes(
  `${namespace}/UPDATE_ASSIGNMENT_CHANGESET_PROPERTY`,
);

export const updateAssignmentChangesetProperty = makeApiActionCreatorV3(
  api.updateAssignmentChangesetProperty,
  UPDATE_ASSIGNMENT_CHANGESET_PROPERTY[START],
  UPDATE_ASSIGNMENT_CHANGESET_PROPERTY[SUCCESS],
  UPDATE_ASSIGNMENT_CHANGESET_PROPERTY[ERROR],
);

export const SUBMIT_ASSIGNMENT_CHANGESET = createRequestTypes(
  `${namespace}/SUBMIT_ASSIGNMENT_CHANGESET`,
);

export const submitAssignmentChangeset = makeApiActionCreatorV3(
  api.submitAssignmentChangeset,
  SUBMIT_ASSIGNMENT_CHANGESET[START],
  SUBMIT_ASSIGNMENT_CHANGESET[SUCCESS],
  SUBMIT_ASSIGNMENT_CHANGESET[ERROR],
);

export const MASS_UPDATE_ASSIGNMENT_CHANGESET_PROPERTY = createRequestTypes(
  `${namespace}/MASS_UPDATE_ASSIGNMENT_CHANGESET_PROPERTY`,
);

export const massUpdateAssignmentChangesetProperty = makeApiActionCreatorV3(
  api.massUpdateAssignmentChangesetProperty,
  MASS_UPDATE_ASSIGNMENT_CHANGESET_PROPERTY[START],
  MASS_UPDATE_ASSIGNMENT_CHANGESET_PROPERTY[SUCCESS],
  MASS_UPDATE_ASSIGNMENT_CHANGESET_PROPERTY[ERROR],
);

export const REJECT_AFTER_APPROVAL_ASSIGNMENT_CHANGESET_PROPERTY = createRequestTypes(
  `${namespace}/REJECT_AFTER_APPROVAL_ASSIGNMENT_CHANGESET_PROPERTY`,
);

export const rejectAfterApprovalAssignmentChangesetProperty = makeApiActionCreatorV3(
  api.rejectAfterApprovalAssignmentChangesetProperty,
  REJECT_AFTER_APPROVAL_ASSIGNMENT_CHANGESET_PROPERTY[START],
  REJECT_AFTER_APPROVAL_ASSIGNMENT_CHANGESET_PROPERTY[SUCCESS],
  REJECT_AFTER_APPROVAL_ASSIGNMENT_CHANGESET_PROPERTY[ERROR],
);

export const MASS_PROCESS_PENDING_CHANGES = createRequestTypes(
  `${namespace}/MASS_PROCESS_PENDING_CHANGES`,
);

export const massProcessPendingChanges = makeApiActionCreatorV3(
  api.massProcessPendingChanges,
  MASS_PROCESS_PENDING_CHANGES[START],
  MASS_PROCESS_PENDING_CHANGES[SUCCESS],
  MASS_PROCESS_PENDING_CHANGES[ERROR],
);

export const FETCH_CHANGESET_GROUP_PROPERTIES = createRequestTypes(
  `${namespace}/FETCH_CHANGESET_GROUP_PROPERTIES`,
);

export const fetchChangesetGroupProperties = makeApiActionCreatorV3(
  api.fetchChangesetGroupProperties,
  FETCH_CHANGESET_GROUP_PROPERTIES[START],
  FETCH_CHANGESET_GROUP_PROPERTIES[SUCCESS],
  FETCH_CHANGESET_GROUP_PROPERTIES[ERROR],
);

export const SUBMIT_CHANGESET_GROUP = createRequestTypes(
  `${namespace}/SUBMIT_CHANGESET_GROUP`,
);

export const submitChangesetGroup = makeApiActionCreatorV3(
  api.submitChangesetGroup,
  SUBMIT_CHANGESET_GROUP[START],
  SUBMIT_CHANGESET_GROUP[SUCCESS],
  SUBMIT_CHANGESET_GROUP[ERROR],
);

export const FETCH_DEFAULT_PRIORITY_CRITERIA = createRequestTypes(
  `${namespace}/FETCH_DEFAULT_PRIORITY_CRITERIA`,
);

export const fetchDefaultPriorityCriteria = makeApiActionCreatorV3(
  api.fetchDefaultPriorityCriteria,
  FETCH_DEFAULT_PRIORITY_CRITERIA[START],
  FETCH_DEFAULT_PRIORITY_CRITERIA[SUCCESS],
  FETCH_DEFAULT_PRIORITY_CRITERIA[ERROR],
);

export const UPDATE_DEFAULT_PRIORITY_CRITERIA = createRequestTypes(
  `${namespace}/UPDATE_DEFAULT_PRIORITY_CRITERIA`,
);

export const updateDefaultPriorityCriteria = makeApiActionCreatorV3(
  api.updateDefaultPriorityCriteria,
  UPDATE_DEFAULT_PRIORITY_CRITERIA[START],
  UPDATE_DEFAULT_PRIORITY_CRITERIA[SUCCESS],
  UPDATE_DEFAULT_PRIORITY_CRITERIA[ERROR],
);
